<Panel :header="title" style="min-width: 25em; height: 100%">
    <template #icons>
        <Button :disabled="errorLoading" size="small" @click="goToTopUpWallet">
            {{ isMobileWidth ? 'Opladen' : 'Saldo&nbsp;opladen' }}
            <plus-circle-icon />
        </Button>
    </template>
    <template v-if="loading">
        <aeg-loader />
    </template>
    <template v-else-if="errorLoading">
        <aeg-error-loading error-message="Er ging iets mis bij het ophalen van uw saldo." @try-again="reload" />
    </template>
    <template v-else>
        <div class="flex flex-col items-center">
            <i class="pi pi-wallet" style="font-size: 2.5rem; padding-bottom: 1rem;" />
            <div class="heading-4" style="margin-bottom: 0;">{{ formatCurrency(serviceWallet.walletAmount) }}</div>
        </div>
    </template>
</Panel>

